import * as React from 'react'
import { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import AxiosClient from '../../utils/axios'
import ErrorMessage from '../../utils/errorMessage'
import LoadingBar from '../../components/loading/LoadingBar'
import HttpErrorNotification from '../../components/notifications/HttpErrorNotification'
import PageTitle from '../../components/title/PageTitle'
import EditIcon from '@mui/icons-material/Edit'
import { Button, Paper, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Breadcrumb from '../../components/breadcrumb/Breadcrumb'

const fetch = async () => {
  const result = await AxiosClient.get('/category')
  return result.data
}

export default function Categories() {
  const nav = useNavigate()
  const [categories, setCategories] = useState([])
  const [alert, setAlert] = useState({ state: false, message: '' })
  const [sendRequest, setSendRequest] = useState(true)
  const editHandler = (id) => nav(`/category/${id}/edit`)
  const createHandler = () => nav(`/category/create`)

  useEffect(() => {
    fetch()
      .then(setCategories, (error) => {
        const message = ErrorMessage(error)
        setAlert({
          state: true,
          message,
        })
      })
      .finally(() => setSendRequest(false))
  }, [])

  const columns = [
    {
      field: 'name',
      headerName: 'Ismi (default)',
      sortable: false,
      editable: false,
      flex: 0.3,
    },
    {
      field: 'name_uz',
      headerName: "O'zbekcha",
      sortable: false,
      editable: false,
      flex: 0.3,
    },
    {
      field: 'name_ru',
      headerName: 'Русский',
      sortable: false,
      editable: false,
      flex: 0.3,
    },
    {
      field: 'name_eng',
      headerName: 'English',
      sortable: false,
      editable: false,
      flex: 0.3,
    },
    {
      field: 'description',
      headerName: 'Izoh',
      sortable: false,
      editable: false,
      flex: 0.4,
    },
    {
      field: 'action',
      headerName: '',
      renderCell: (params) => {
        return (
          <Grid container justifyContent="flex-end">
            <Button onClick={editHandler.bind(this, params.id)}>
              <EditIcon />
            </Button>
          </Grid>
        )
      },
    },
  ]

  return (
    <Paper sx={{ p: 1 }}>
      <Grid container sx={{ p: 1 }}>
        <Grid item xs={10}>
          <PageTitle title="Kategoriya" />
        </Grid>
        <Grid item xs={2}>
          <Grid container justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={createHandler}>
              +
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <div style={{ width: '100%' }}>
        <DataGrid
          rows={categories}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10]}
          getRowId={(row) => row._id}
          disableRowSelectionOnClick
        />
      </div>
      {alert.state ? <HttpErrorNotification message={alert.message} /> : <></>}
      {sendRequest ? <LoadingBar /> : <></>}

      <Breadcrumb />
    </Paper>
  )
}
